/* <kit-feature-cards>: swipe rail progress, desktop arrows, play videos only while on screen. */
if (!customElements.get('kit-feature-cards')) {
  class KitFeatureCards extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.thumb = this.querySelector('[data-thumb]');
      this.count = this.querySelector('[data-count]');
      if (!this.rail) return;
      this.total = this.rail.querySelectorAll('.kit-fc__card').length;

      let raf;
      this.onScroll = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.update());
      };
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      window.addEventListener('load', this.onScroll, { once: true });
      this.update();

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));

      this.setupVideos();
    }

    disconnectedCallback() {
      this.rail?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.observer?.disconnect();
    }

    step(dir) {
      const card = this.rail.querySelector('.kit-fc__card');
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 12;
      this.rail.scrollBy({ left: dir * ((card ? card.offsetWidth : 280) + gap), behavior: 'smooth' });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.rail;
      const max = scrollWidth - clientWidth;
      const progress = max > 0 ? Math.min(1, Math.max(0, scrollLeft / max)) : 0;
      const visible = scrollWidth > 0 ? Math.min(1, clientWidth / scrollWidth) : 1;
      if (this.thumb) {
        this.thumb.style.width = `${visible * 100}%`;
        this.thumb.style.left = `${progress * (1 - visible) * 100}%`;
      }
      if (this.count) this.count.textContent = `${Math.round(progress * (this.total - 1)) + 1} / ${this.total}`;
      // Everything fits (e.g. 4 cards on desktop): arrows and progress have nothing to do.
      this.classList.toggle('is-static', max <= 1);
    }

    setupVideos() {
      const videos = [...this.querySelectorAll('video')];
      if (!videos.length) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      videos.forEach((v) => {
        v.muted = true;
        v.removeAttribute('autoplay');
        if (!reduced) v.pause();
      });
      if (reduced || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, intersectionRatio }) => {
          if (intersectionRatio >= 0.5) target.play().catch(() => {});
          else target.pause();
        });
      }, { threshold: [0, 0.5, 1] });
      videos.forEach((v) => this.observer.observe(v));
    }
  }
  customElements.define('kit-feature-cards', KitFeatureCards);
}
